<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <i class="fas fa-list"></i> {{ $t('page.title.bonus_definition') }}
      <template v-slot:right>
        <b-button @click="openModal('create')" size="sm" class="ml-1" variant="success">{{ $t('btn.add_new_bonus') }}</b-button>
      </template>
      <create-modal @refreshGrid="loadItems(defaultFilters)" ref="game-result-details-modal"></create-modal>
      <edit-active-bonus-modal ref="edit-active-bonus-modal" @refreshGrid="loadItems(defaultFilters)"></edit-active-bonus-modal>
      <bonus-definition-details-modal @refreshGrid="loadItems(defaultFilters)" ref="game-result-details-modal"></bonus-definition-details-modal>
    </page-header>

    <page-card>
      <template v-slot:header>
        {{ $t('page.list')}}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">
          <grid-pagination :total-count="totalCount"
                           :per-page="perPage"
                           :current-page="currentPage"
                           @load-items="paginationReload"></grid-pagination>
          <div class="table-responsive">
            <b-table striped
                     :busy="isBusy"
                     hover
                     head-variant="dark"
                     outlined
                     :sort-by.sync="orderColumn"
                     :sort-desc.sync="orderDirection"
                     :empty-text="$t('table.no_results')"
                     :no-local-sorting="true"
                     :items="items"
                     :fields="fields">

              <template #cell(id)="data">
                {{ data.item.id | shortId }}
              </template>

              <template #cell(status)="data">
                <b-badge pill variant="primary" v-if="data.item.status === 'DRAFT'">{{$t('bonus_status_'+ data.value )}}</b-badge>
                <b-badge pill variant="success" v-if="data.item.status === 'ACTIVE'">{{$t('bonus_status_'+ data.value )}}</b-badge>
                <b-badge pill variant="secondary" v-if="data.item.status === 'INACTIVE'">{{$t('bonus_status_'+ data.value )}}</b-badge>
              </template>

              <template #cell(validFrom)="data">
                {{ data.value | dateFormat('YYYY-MM-DD HH:mm:ss') }}
              </template>

              <template #cell(validTo)="data">
                {{ data.value | dateFormat('YYYY-MM-DD HH:mm:ss') }}
              </template>

              <template #cell(bonusCodes)="data">
                {{ data.item.bonusCodes }}
              </template>

              <template #cell(bonusCodes)="data">
                <div v-for="(bonusCode) in data.item.bonusCodes" :key="bonusCode">
                  <template v-if="bonusCode">
                    {{ bonusCode }}
                  </template>
                </div>
              </template>

              <template #cell(triggers)="data">
                <div v-for="(trigger) in data.item.triggers" :key="trigger">
                  <template v-if="trigger">
                    {{ trigger }}
                  </template>
                </div>
              </template>

              <template #cell(actions)="data">
                <div class="table-action--cell">
                  <b-button v-if="data.item.status === 'DRAFT'" variant="success" size="sm" @click="bonusPublish(data.item)">{{ $t('table.btn.bonus.publish') }}</b-button>
<!--                  <b-button v-if="data.item.status === 'DRAFT'" variant="warning" size="sm" @click="openModal('edit', data.item)">{{ $t('table.btn.bonus.edit_draft') }}</b-button>-->
                  <b-button v-if="data.item.status === 'ACTIVE'" variant="danger" size="sm" @click="bonusDeactivate(data.item)">{{ $t('table.btn.bonus.deactivate') }}</b-button>
                  <b-button v-if="data.item.status === 'ACTIVE'" variant="warning" size="sm" @click="editActiveBonus(data.item)">{{ $t('table.btn.bonus.edit_active') }}</b-button>
<!--                  <b-button variant="success" size="sm" @click="openModal('details', data.item)">{{ $t('table.btn.details') }}</b-button>-->
<!--                  <b-button variant="success" size="sm" @click="openModal('details', data.item)">{{ $t('table.btn.details') }}</b-button>-->
                </div>
              </template>

              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>{{$t('state.loading')}}</strong>
                </div>
              </template>
            </b-table>
          </div>
          <grid-pagination :total-count="totalCount"
                           :per-page="perPage"
                           :current-page="currentPage"
                           @load-items="paginationReload"></grid-pagination>
        </div>
      </template>
      <template v-slot:footer>

      </template>
    </page-card>

  </div>
</template>

<script>
import GridMixin from "../../components/grid/GridMixin";
import CreateModal from "./CreateModal";
import EditActiveBonusModal from "./EditActiveBonusModal";
import BonusDefinitionDetailsModal from "./BonusDefinitionDetailsModal";
import GridPagination from "../../components/grid/grid-pagination/GridPagination";
import PageHeader from "../../components/page/PageHeader";
import PageCard from "../../components/page/PageCard";
import Vue from "vue";
import axios from "axios";

export default {
  mixins: [GridMixin],
  components: {
    PageCard,
    PageHeader,
    BonusDefinitionDetailsModal,
    EditActiveBonusModal,
    GridPagination,
    CreateModal
  },
  data() {
    return {
      gridGetUrl: '/api/bonus-definition',
      defaultFilters: '',
      fields: [
        {key: 'id', label: this.$t('table.header.bonus_id'), sortable: false},
        {key: 'name', label: this.$t('table.header.bonus_name'), sortable: true},
        {key: 'currency', label: this.$t('table.header.bonus_currency'), sortable: true},
        {key: 'validFrom', label: this.$t('table.header.bonus_valid_from'), sortable: true},
        {key: 'validTo', label: this.$t('table.header.bonus_valid_to'), sortable: true},
        {key: 'bonusCodes', label: this.$t('table.header.bonus_codes'), sortable: true},
        {key: 'daysToCompleteWager', label: this.$t('table.header.bonus_days_to_complete_wager'), sortable: true},
        {key: 'description', label: this.$t('table.header.bonus_description'), sortable: true},
        {key: 'factorType', label: this.$t('table.header.bonus_factor_type'), sortable: true},
        {key: 'factorValue', label: this.$t('table.header.bonus_factor_value'), sortable: true},
        {key: 'isBonusCode', label: this.$t('table.header.bonus_is_bonus_code'), sortable: true},
        {key: 'maxBonusAmount', label: this.$t('table.header.bonus_max_bonus_amount'), sortable: true},
        {key: 'minDeposit', label: this.$t('table.header.bonus_min_deposit'), sortable: true},
        {key: 'period', label: this.$t('table.header.bonus_period'), sortable: true},
        {key: 'triggers', label: this.$t('table.header.bonus_triggers'), sortable: true},
        {key: 'type', label: this.$t('table.header.bonus_type'), sortable: true},
        {key: 'wagerLockType', label: this.$t('table.header.bonus_wager_lock_type'), sortable: true},
        {key: 'wagerType', label: this.$t('table.header.bonus_wager_type'), sortable: true},
        {key: 'wagerValue', label: this.$t('table.header.bonus_wager_value'), sortable: true},
        {key: 'wagerValue', label: this.$t('table.header.bonus_wager_value'), sortable: true},
        {key: 'agreement3Requirement', label: this.$t('table.header.agreement_3_requirement'), sortable: true},
        {key: 'agreement4Requirement', label: this.$t('table.header.agreement_4_requirement'), sortable: true},
        {key: 'status', label: this.$t('table.header.bonus_bonus_status'), sortable: true},
        {key: 'actions', label: this.$t('table.header.actions'), sortable: false}
      ],
      perPage: 10,
      currentPage: 1,
      orderColumn: null,
      orderDirection: false,
      // filterQuery: [],
      detailsModalInstance: null,
      createModalInstance: null

    };
  },
  mounted() {
    this.$on('refreshGrid', () => {
      this.applyFilters();
    })

  },
  computed: {
    walletCurrency: function () {
      return this.$store.getters["root/walletCurrency"].map(d => {
        return {
          value: d.value,
          text: this.$t(d.value)
        }
      });
    },
  },
  methods: {
    editActiveBonus(item) {
      this.$refs['edit-active-bonus-modal'].openModal(item);
    },
    storeFilter(data) {
      this.$store.commit('root/setFilter', {storeName: 'players', ...data})
    },
    // resetFilters() {
    //   this.filterQuery = [];
    //   this.$root.$emit('resetFilters');
    //   // this.initFilters();
    //   this.applyFilters();
    // },
    bonusPublish(item) {
      this.$bvModal.msgBoxConfirm(this.$t('bonus.publish_title') + item.name, {
        title: this.$t('bonus.publish.are_you_sure'),
        okTitle: this.$t('btn.bonus_publish_ok'),
        cancelTitle: this.$t('btn.cancel'),
        okVariant: 'success',
      })
      .then(value => {
        if (value) {
          axios.post('/api/bonus-definition/publish', { id: item.id })
            .then(() => {
              this.loadItems();
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    bonusDeactivate(item) {
      this.$bvModal.msgBoxConfirm(this.$t('bonus.deactivate.title') + item.name, {
        title: this.$t('bonus.publish.are_you_sure'),
        okTitle: this.$t('btn.bonus_deactivate_ok'),
        cancelTitle: this.$t('btn.cancel'),
        okVariant: 'danger',
      })
          .then(value => {
            if (value) {
              axios.post('/api/bonus-definition/deactivate', { id: item.id })
                  .then(() => {
                    this.loadItems();
                  })
                  .catch(error => {
                    console.log(error);
                  });
            }
          });
    },
    openModal(modalName, data) {
      let ModalConstructor;
      switch(modalName) {
        case('create'): {
          // if(!this.createModalInstance){
            ModalConstructor = Vue.extend(CreateModal)
            this.createModalInstance = new ModalConstructor({parent: this});
            this.createModalInstance.$mount();
            this.createModalInstance.openModal();
          // }
          break;
        }
        case('edit'): {
          // if(!this.createModalInstance){
          ModalConstructor = Vue.extend(CreateModal)
          this.createModalInstance = new ModalConstructor({parent: this, propsData: { data: data, isEditType: true }});
          this.createModalInstance.$mount();
          this.createModalInstance.openModal();
          // }
          break;
        }
        case('details'): {
          if(!this.detailsModalInstance){
            ModalConstructor = Vue.extend(BonusDefinitionDetailsModal)
            this.detailsModalInstance = new ModalConstructor({parent: this});
            this.detailsModalInstance.$mount();
          }
          this.detailsModalInstance.showDetails(data);
          break;
        }
      }
    }
  }
}
</script>
